import React from "react";
import PersonIcon from "@material-ui/icons/Person";
import { Avatar } from "@material-ui/core";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";
import { H6 } from "../common/styles/typography";
import { SPACING_12 } from "../common/styles/spacing";
import { FONT_1, FONT_0_75, HEADING_FONT } from "../common/styles/fonts";
import { RootState } from "../../store";
import { User } from "./userSlice";
import { GRAY_900 } from "../common/styles/colors";
import { getInitials } from "../common/utils";

const StyledUser = styled.div`
    display: flex;
    align-items: center;
    max-width: 25%;
`;

const UserName = styled(H6)`
    margin-right: ${SPACING_12};
    font-size: ${FONT_1};

    text-transform: capitalize;

    word-break: break-word;
    text-align: right;
`;

const StyledInitials = styled.span`
    font-family: ${HEADING_FONT};
    color: ${GRAY_900};
    font-size: ${FONT_0_75};
    font-weight: bold;
`;

/* The User component will attempt to display an avatar with
 * with a picture of the user, if that fails it will display a gray
 * gray circle with the initials of the individual, and if there is no name,
 * it will just display a placeholder person icon
 */
export default () => {
    const user = useSelector<RootState, User | undefined>((state) => state.user.user);
    const userProfileImage = user?.photoURL || undefined;
    const userDisplayName = user?.displayName || "";
    const userInitials = getInitials(userDisplayName);

    return (
        <StyledUser>
            {userDisplayName && <UserName>{userDisplayName}</UserName>}
            <Avatar src={userProfileImage} alt={userDisplayName}>
                {userInitials ? (<StyledInitials>{userInitials}</StyledInitials>) : <PersonIcon />}
            </Avatar>
        </StyledUser>
    );
};
